import { observable, action } from 'mobx';
import { saveAs } from 'file-saver';
import { http, addVisitLog, history } from 'libs';
import { message } from 'antd';
// import moment from "moment";

class Store {
  @observable records = [];
  @observable record = {};
  @observable fetching = false;
  @observable formVisible = false;
  @observable selectDisable = false;
  @observable userOptions = [];
  @observable companyList = []; // 单位名称列表
  @observable accountUserList = []; // 用户列表
  @observable accountOptions = [] //单位名称下拉列表
  @observable sourceTypeList = [] //项目渠道列表
  //搜索条件
  @observable page = 1;
  @observable pageSize = localStorage.getItem('projectPageSize') || 10;
  @observable pageTotal = 0;
  @observable projectNo = null;
  @observable orgId = null;
  @observable orgName = null;
  @observable status = null;
  @observable manageUserId = null;
  @observable manageUserName = null;
  @observable updateUserName = null;
  @observable applyUserName = null;
  @observable updateTime = null;


  // constructor() {
  //   initStore(this, makeAutoObservable)
  // }

  pageChange = (page, size) => {
    this.records = []
    this.page = page;
    this.pageSize = size;
    localStorage.setItem('projectPageSize',size);
    this.fetchRecords()
}

  fetchRecords = () => {
    this.fetching = true;
    let query = {
      pageNo: this.page,
      pageSize: this.pageSize,
      projectNo: this.projectNo,
      orgName: this.orgName,
      status: this.status,
      sourceType: 'CLINICAL',
      manageUserName: this.manageUserName,
      applyUserName: this.applyUserName,
      updateTime1: this.updateTime&&this.updateTime[0],
      updateTime2: this.updateTime&&this.updateTime[1],
    }
    return http.post('/javaApi/front/project/list',{ 
      pageNo: this.page,
      pageSize: this.pageSize, 
      param: query,
    })
      .then(action('a', res => {
        this.records = res.data.result.data
        this.pageTotal = res.data.result.pageInfo.totalRows;
        // this.page_total_price = res.total_price || 0;
        // this.page_total_price_without_tax = res.total_price_without_tax || 0;
        // if (this.f_type === '1') {
        //     this.records = res.sale
        // } else if (this.f_type === '2') {
        //     this.records = res.lease
        // } else if (this.f_type === '3') {
        //     this.records = res.serve
        // } else {
        //     this.records = res.period
        // }
    }))
      .finally(action('b', () => this.fetching = false))
  };

  async exportLog(data) {
    const url = '/javaApi/front/export/projectExcel';
    const res = await http({
      url: url,
      method: 'get',
      params:data,
      responseType: 'arraybuffer',
      headers: {
        token: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return res;
  }

  onExport = () => {
    let query = {
      pageNo: this.page,
      pageSize: this.pageSize,
      projectNo: this.projectNo,
      orgName: this.orgName,
      status: this.status,
      manageUserName: this.manageUserName,
      applyUserName: this.applyUserName,
      updateTime1: this.updateTime&&this.updateTime[0],
      updateTime2: this.updateTime&&this.updateTime[1],
    }
    this.exportLog(query).then(res => {
      if (res) {
        let url = window.URL.createObjectURL(
          new Blob([res.data], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          }),
        );
        saveAs(url,'项目列表.xls');
      } else {
        message.error('导出失败');
      }
    });
    addVisitLog({
      pageName: '导出项目',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: "ExportProject",
      eventName: "导出项目",
    })
  }

  // 请求单位名称列表
  fetchAccount = (data) => { // {nameLike:客户名称(模糊搜索),invoiceCode:发票编码,maxResult:查询最大条数}
    let params = {}
    if (typeof(data)==='undefined') {
        params = {nameLike:'',businessUnitIdLeft:'000115'}
    }else if(typeof(data)==='string'){
        params = {nameLike:data,businessUnitIdLeft:'000115'}
    }else if(typeof(data)==='object'){
        params = data
    }
    return http.post(process.env.REACT_APP_CRM_API_URL+'outApi/account/listAll', {...params,maxResult:50})
    .then(res => {
        this.companyList = res.data.result;
        this.userOptions = []
        this.accountOptions = this.companyList.map((item)=>({
            label:item.name,
            value:item.code,
            key: item.id,
        }));
        return this.accountOptions;
    })
  }

  // 请求用户列表
fetchAccountUser = (data) => { // {accountCode:客户CODE}
    http.post(process.env.REACT_APP_CRM_API_URL+'outApi/contact/listAll', data)
    .then(res => {
        this.accountUserList = res.data.result;
        this.userOptions = this.accountUserList.map(item=>({
            ...item,
            label:item.name,
            value:item.code,
            key: item.id,
        }));
    })
  }

  fetchSourceTypeList = () => {
    http.get('/javaApi/front/common/sourceTypeList')
      .then(res => this.sourceTypeList = res.data.result)
  }


  onRowsChange = (rows, keys) => {
    console.log(rows, keys)
  }

  showForm = (info) => {
    this.record = info || {};
    this.formVisible = true
  }
}

export default new Store()